import React, { useEffect, useState } from 'react';
import { useRouteData } from 'react-static';
// services & helpers
import FrontendHttpService from '@nmx/utils-frontend/dist/services/FrontendHttpService';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// styles
import { TableStyled } from './styles';

export default () => {
  const [unitvals, setUnitvals] = useState({ models: [] });
  const { pageProps } = useRouteData();

  class MsFundsService {
    static getUnitvals() {
      return new Promise((resolve, reject) => {
        this.httpService.get('/unitvals.json')
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    }
  }

  MsFundsService.httpService = new FrontendHttpService({ baseURL: pageProps.msFundsBaseUrl });

  useEffect(() => {
    MsFundsService.getUnitvals()
      .catch(() => {
        console.error('An error occurred while fetching unitvals');
      })
      .then((data) => {
        setUnitvals(data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SectionContainer
      id='daily-unit-values-income-plans'
      backgroundVariant='lightB'
      themeType='lightTheme'>
      <Row align='center'>
        <Col medium={8}>
          <Typography
            component='h2'
            align='center'
            nextElement='typography'>
            Income Plans
          </Typography>
          <Typography nextElement='graphic'>
            To view daily unit values for a specific Northwestern Mutual Life income plan, click the account name below. The underlying separate accounts listed here are part of the Northwestern Mutual Series Fund, Inc., Fidelity&#174; Variable Insurance Products, Neuberger Berman, LLC., and Russell Investment Funds.
          </Typography>
        </Col>
      </Row>
      <Row align='center'>
        <Col
          medium={10}
          align='center'>
          <TableStyled
            variant='branded'
            tableData={{
              caption: { children: 'Daily Unit Values account name' },
              summary: 'This table shows the account names for the Daily Unit Values.',
              tableHead: {
                rows: [
                  {
                    cols: [
                      { children: 'Account names' },
                      { children: 'Assumed Investment Rates' },
                      { children: 'Assumed Investment Rates' },
                    ],
                  },
                ],
              },
              tableBody: {
                rows: unitvals.models.map(entry => ({
                  cols: [
                    {
                      children: entry.name,
                      rowScope: 'row',
                    },
                    {
                      children: <>3.5&#37;</>,
                      rowScope: 'row',
                    },
                    {
                      children: <>5.0&#37;</>,
                      rowScope: 'row',
                    },
                  ],
                })),
                displayStripedRows: true,
              },
            }}
          />
          <Link
            id='daily-unit-values-income-plans-button-link'
            variant='buttonLinkPrimary'
            linkUrl='/annuities/daily-unit-values/daily-unit-values-income-annuities/'>
            View Daily Unit Values For Income Plans
          </Link>
        </Col>
      </Row>
    </SectionContainer>
  );};
